import React, { useEffect, useState } from "react";
import MultiSelect from "../../common/TextField/dropDown";
import { useDispatch, useSelector } from "react-redux";
import Modal from "./modal";
import { fetchDepsUnits } from "../../Login/action";
import useConfiguration from "../../../hooks/useConfiguration";
import requestUtil from "../../../helpers/requestUtil";
import { toast } from "react-toastify";
import { getCandidateLocationStatus } from "../../Candidates/Search/CandidateSearchView/action";
import useSessionStorage from "../../../hooks/useSessionStorage";
import { setLoading } from "../Loader/slice";
import Loader from "../Loader";
import * as Toasts from "../../common/Toastify";
const DepsUnitsModal = ({ state,updateState , updateTableData,currentStatusId,updateStatusOfEmployer,updateEmpDepStatus}) => {
  // console.log({state});
  const dispatch = useDispatch();
  const depsUnitsMaster = useSelector((store) => store.login.depsUnitsMaster);
  const [depsUnits, setDepsUnits] = useState([]);
  const [depsError,setDepsError] = useState("");
  const [isDepartmentsExist, setIsDepartmentsExist] = useState(false);
  const [initialDepartmentList, setInitialDepartmentList] = useState([]);
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const depsUnitsChangeHandler = (e) => {
    const { action, value, name } = e;
    let copyDepsUnits = [...depsUnits];
    if (action === "add") {
      copyDepsUnits.push(value);
    } else if (action === "remove") {
      copyDepsUnits = copyDepsUnits?.filter((item) => item?.id !== value?.id);
    }
    setDepsUnits(copyDepsUnits)
    // dispatch(setCreationValue({name,value:copyDepsUnits}))
  };
  const getMappedDepartmentsToCandi = async ({ candidateUniqueId,locationId }) => {
    dispatch(setLoading(true));
    try {
      const response = await requestUtil(
        `${config?.baseUrl}/Departments/get-mapped-department-candidate?candidateUniqueIdId=${candidateUniqueId}&locationId=${locationId}`
      );
      const result = response?.departmentsMembersListList?.length ? response?.departmentsMembersListList : []
      return result
    } catch (error) {
      return error?.message
    } finally {
      dispatch(setLoading(false));
    }
  };
  const mapDepartmentsToCandidate = async ({params}) => {
    dispatch(setLoading(true));
    try {
      const response = await requestUtil(`${config?.baseUrl}/Departments/map-department-candidate`, "POST", { ...params });
      if(response?.result){
        updateTableData && updateTableData(state,depsUnits)
      }
      toast.success(response?.message);
      return response?.result ? true : false;
    } catch (error) {
      toast.error(error?.message)
      return false;
    } finally {
      dispatch(setLoading(false));
    }
  };

  const getFilterElements = (selectedValue,masterValue) => {
    const filterDepartments = [];
    const idSets = new Set(masterValue?.map(item => item?.id));
    selectedValue?.forEach(deps => {
      if(idSets?.has(deps?.candidateDepartmentId)){
        filterDepartments?.push({id:deps?.candidateDepartmentId,name:deps?.departmentName})
      }
    });
   setDepsUnits(filterDepartments);
   setInitialDepartmentList(selectedValue?.map(item => item?.candidateDepartmentId));
   if(selectedValue?.length){
    setIsDepartmentsExist(true);
   } else {
    setIsDepartmentsExist(false)
   }
  }
  useEffect(() => {
    if(config.baseUrl && state?.element?.locationId &&state?.element?.candidateUniqueId){
      getMappedDepartmentsToCandi({candidateUniqueId:state?.element?.candidateUniqueId,locationId:state?.element?.locationId}).then((mappedCandis) => {
        if (depsUnitsMaster?.length === 0) {
          dispatch(fetchDepsUnits({ baseUrl: config.baseUrl })).then(
            (response) => {
              if (response) {
                getFilterElements(mappedCandis?.length ? mappedCandis : [],response);
              }
            }
          );
        } else {
          getFilterElements( mappedCandis?.length ? mappedCandis : [],depsUnitsMaster);
        }
      });
    }
  }, [config.baseUrl,state?.element?.candidateUniqueId,state?.element?.locationId,depsUnitsMaster?.length]);
  const closeHandler = () => {
    // if(!isDepartmentsExist && depsUnits?.length === 0 ){
    //   setDepsError("Please select department");
    //   return
    // } 
    // else if(!isDepartmentsExist && depsUnits?.length > 0 ) {
    //   setDepsError("Please save selected departments");
    //   return
    // } else {
    //   setDepsError("")
    // }
    //  if(depsUnits?.length === 0 && depsUnitsMaster?.length > 0 ){
    //   setDepsError("Please select department");
    //   return
    // };
    if(!isDepartmentsExist){
      updateStatusOfEmployer(false,true);
      // Toasts.error('The candidate status is not updated. Please select a department.')
    } else {
      updateStatusOfEmployer(false);
    }
    updateState(prev => ({...prev,status:false,element:{}}));
  };
  const saveHandler = () => {
    if(depsUnits && depsUnits?.length === 0){
      setDepsError("Please select department");
      return
    } else {
      setDepsError("")
    }
    let unMappedStatus = false;
    const depsIdList  = depsUnits?.length ? depsUnits?.map((depUnit) => depUnit?.id) : []
    initialDepartmentList?.forEach(initialDepsId => {
      if(depsIdList?.indexOf(initialDepsId) < 0){
        unMappedStatus = true
      }
    })
    const mappedParams = {
      locationId :  state?.element?.locationId  ?  state?.element?.locationId  : "",
      candidateUniqueId: state?.element?.candidateUniqueId  ? state?.element?.candidateUniqueId : "",
      candidateDepartmentId: depsIdList,
      employerCandidateStatusID:+currentStatusId,
      isUnmapped: unMappedStatus
    };
    updateState(prev => ({...prev,status:false,element:{}}));
     updateEmpDepStatus({mappedParams,isDepartmentsExist});
    // const isUpdated = await mapDepartmentsToCandidate({params});
    // if(!isUpdated) {
    //   Toasts.error('The candidate status is not updated. Please select a department.')
    // }
    // if(!isDepartmentsExist){
    //   updateStatusOfEmployer(isUpdated,!isUpdated);
    //   // Toasts.error('The candidate status is not updated. Please select a department.')
    // } else {
    //   updateStatusOfEmployer(isUpdated);
    // }
    // if(state?.page === "candidatesearchview"){
    //   const params =  {
    //     employerUniqueId: login.employerUniqueId,
    //     candidateUniqueId: state?.element?.candidateUniqueId,
    //   }
    //   dispatch(getCandidateLocationStatus({url: `${config.baseUrl}/Candidates/get-employers-location-candidate-status-list`,params}))
    // }
  };
  return (
    <>
      <Loader />
      <Modal
        showHide={closeHandler}
        label={"Departments"}
        size={"lg"}
        center={true}
        saveFunction={saveHandler}
      >
        <div className="card">
          <p>Select departments for {state?.element?.firstName} {state?.element?.lastName} <span class="required">*</span> </p>
          <MultiSelect
            divClass={"w-100"}
            name={"depsUnits"}
            id={"depsUnits"}
            value={depsUnits}
            options={depsUnitsMaster}
            multiple={true}
            updateValue={depsUnitsChangeHandler}
            isObject={true}
            errors={depsError ? [depsError] : []}
            // multiselectRef={certificationRef}
          />
        </div>
      </Modal>
    </>
  );
};

export default DepsUnitsModal;
